export class StringUtility {
  public static isNullOrUndefeinedOrEmpty(value: string | null | undefined): boolean {
    return value == null || value === "";
  }
}
